import { axiosInstance as axios } from "../../Editor/services/axios-provider";

import { useStore } from "vuex";

export default class AuthorizationInterceptor {
  constructor(private allowedUrls: string[]) {}
  private authStore = useStore();
  public enable() {
    axios.interceptors.request.use(async (request) => {
      if (
        this.allowedUrls.some((el) => {
          return request.baseURL?.startsWith(el);
        })
      ) {
        const accessToken = this.authStore.getters.oidcAccessToken;

        if (accessToken) {
          request.headers.Authorization = `Bearer ${accessToken}`;
        }
      }
      return request;
    });

    axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          // TODO emit error #893
          this.authStore.dispatch("signOutOidc");
        }
        return Promise.reject(error);
      }
    );
  }
}
